<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>项目管理</el-breadcrumb-item>
      <el-breadcrumb-item>项目列表</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="form-horizontal">
      <div class="panel">
        <el-page-header
          @back="$router.go(-1)"
          :content="model.id ? '编辑项目' : '添加项目'"
        >
        </el-page-header>
        <div class="row">
          <el-form :model="model" :rules="rules" ref="ruleForm">
            <div class="col-sm-7 p-t-10">
              <div class="form-group">
                <label class="col-md-4 control-label">井号</label>
                <div class="col-md-8">
                  <el-form-item label="" prop="pit_number">
                    <el-input
                      v-model="model.pit_number"
                      size="small"
                      placeholder="井号"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-md-4 control-label">井队</label>
                <div class="col-md-8">
                  <el-form-item label="" prop="pit_team">
                    <el-input
                      v-model="model.pit_team"
                      size="small"
                      placeholder="井队"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-md-4 control-label">区域</label>
                <div class="col-md-8">
                  <el-form-item label="" prop="region">
                    <RegionSelect
                      v-model="model.region"
                      style="width: 100%"
                    ></RegionSelect>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-md-4 control-label">位置</label>
                <div class="col-md-8">
                  <el-form-item label="" prop="position">
                    <el-input
                      v-model="model.position"
                      size="small"
                      placeholder="位置"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-md-4 control-label">服务内容</label>
                <div class="col-md-8">
                  <el-form-item label="" prop="service">
                    <el-input
                      v-model="model.service"
                      size="small"
                      placeholder="服务内容"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-md-4 control-label">主眼设计井深 (m)</label>
                <div class="col-md-8">
                  <el-form-item label="" prop="pit_depth">
                    <el-input
                      v-model="model.pit_depth"
                      size="small"
                      placeholder="主眼设计井深"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-md-4 control-label">服务开始日期</label>
                <div class="col-md-8">
                  <el-date-picker
                    style="width: 100%"
                    v-model="model.start_time"
                    type="date"
                    placeholder="选择日期"
                    size="small"
                    value-format="yyyy-MM-dd"
                  >
                  </el-date-picker>
                </div>
              </div>
              <div class="form-group">
                <label class="col-md-4 control-label">井及状态</label>
                <div class="col-md-8">
                  <StatusSelect
                    v-model="model.status"
                    style="width: 100%"
                  ></StatusSelect>
                </div>
              </div>
              <div class="form-group">
                <label class="col-md-4 control-label">服务人员</label>
                <div class="col-md-8">
                  <UserSelect
                    v-model="model.user_ids"
                    style="width: 100%"
                  ></UserSelect>
                </div>
              </div>
            </div>

            <div class="col-sm-5">
              <div class="" id="panel-cover">
                <div class="panel-heading">
                  <h3 class="panel-title">添加附件</h3>
                </div>
                <div
                  class="panel-body"
                  style="padding-top: 0; padding-bottom: 0"
                >
                  <upload v-model="model.attachments"></upload>
                </div>
              </div>
            </div>
          </el-form>
        </div>
        <div class="panel-footer">
          <div class="row">
            <div class="col-lg-4 col-md-6">
              <div class="col-md-8 col-md-offset-4">
                <el-button type="primary" @click="handlePost">保存</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { projectNew, projectUpdate, projectDetail } from '@/service/getData'

import RegionSelect from '@/components/select/RegionSelect.vue'
import StatusSelect from './status_select.vue'
import UserSelect from './user_select.vue'
import upload from '@/components/upload.vue'

export default {
  components: {
    RegionSelect,
    StatusSelect,
    UserSelect,
    upload,
  },
  data() {
    return {
      rules: {
        pit_number: [
          { required: true, message: '此项不能为空', trigger: 'blur' },
        ],
        pit_team: [
          { required: true, message: '此项不能为空', trigger: 'blur' },
        ],
        region: [
          { required: true, message: '此项不能为空', trigger: 'change' },
        ],
        position: [
          { required: true, message: '此项不能为空', trigger: 'change' },
        ],
        service: [
          { required: true, message: '此项不能为空', trigger: 'change' },
        ],
        pit_depth: [
          { required: true, message: '此项不能为空', trigger: 'change' },
        ],
      },
      model: {
        pit_number: '',
        pit_team: '',
        region: '',
        position: '',
        service: '',
        pit_depth: '',
        start_time: '',
        status: 1,
        user_ids: [],
        attachments: [],
      },
    }
  },
  created() {
    if (this.$route.params.id) {
      this.getProjectDetail(this.$route.params.id)
    }
  },
  methods: {
    handlePost() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          if (this.model.id) {
            let res = await projectUpdate(this.model)
            if (res.code == 0) {
              this.$router.go(-1)
            }
          } else {
            let res = await projectNew(this.model)
            if (res.code == 0) {
              this.$router.go(-1)
            }
          }
        }
      })
    },

    async getProjectDetail(id) {
      let res = await projectDetail(id)
      res.data.user_ids = res.data.users.map((item) => {
        return item.user_id
      })
      this.model = res.data
      console.log(this.model)
    },
  },
}
</script>